export const EPISODE_TYPE = `
    data{
        id
        title
        rating
        restricted
        description
        playCount: play_count
        content
        publishDate
        thumbnail(width: 400, height: 400)
        likes
        dislikes
        userLike
        userDislike
        premium
        original
        external
        channel{
            id
            name
            codename
            main_category {
                id
            }
            flag
            thumbnail
            premium
            original
        }
    }
    total
    per_page
    current_page
    from
    to
    last_page
    has_more_pages
`;
